import { render, staticRenderFns } from "./IssueChatCurrent.vue?vue&type=template&id=77277c93&scoped=true"
import script from "./IssueChatCurrent.vue?vue&type=script&lang=js"
export * from "./IssueChatCurrent.vue?vue&type=script&lang=js"
import style0 from "./IssueChatCurrent.vue?vue&type=style&index=0&id=77277c93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77277c93",
  null
  
)

export default component.exports